import React, { useEffect, useState } from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  Row,
  Col,
  CardFooter,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Toast,
  Collapse,
} from "reactstrap";
import FalconCardHeader from "../common/FalconCardHeader";
import WizardError from "../auth/register/WizardError";
import classNames from "classnames";
import ButtonIcon from "../common/ButtonIcon";
import { Controller, useForm } from "react-hook-form";
import FullPagination from "../common/pagination/FullPagination";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useParams } from "react-router";
import SelectPropertyListItem from "../common/SelectPropertyListItem";
import { PreloadState } from "../UI/preloading/PreloadState";
import { fetchCondominiumPeriod } from "../../helpers/api/finance";
import { useSelector } from "react-redux";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { useCallback } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ReserveFundAmountFields, {
  useReserveFundAmount,
} from "./ReserveFundAmountFields";

const CreateAliquotForm = ({
  handleSubmitData,
  handler,
  properties,
  setRedirect,
  setRedirectUrl,
  aliquot,
}) => {
  const { id } = useParams();
  const history = useHistory();
  const {
    register,
    handleSubmit,
    errors,
    formState: { isSubmitting, isSubmitted },
    setValue,
    control,
    setError,
    clearErrors,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
  });

  const [collapseOne, collapseOneOpen] = useState(false);
  const [openFrecuente, setOpenFrecuente] = useState(false);
  const [openCredito, setOpencredito] = useState(false);
  const [collapseCredito, collapseCreditoOpen] = useState(false);
  const {
    condominium: { selectedCondominium },
  } = useSelector((state) => state);

  console.log(errors);


  const [periods, setPeriods] = useState([]);
  const fetchApiPeriods = useCallback(async () => {
    try {
      const response = await fetchCondominiumPeriod(selectedCondominium);
      setPeriods(
        response.data && response.data.length >= 0 ? response.data : []
      );
      console.log(response);
    } catch (error) {
      setPeriods([]);
    }
  }, []);
  useEffect(() => {
    fetchApiPeriods();
  }, [fetchApiPeriods]);

  const amountState = useReserveFundAmount({ condominiumId: selectedCondominium });
  const { baseAmount } = amountState;

  useEffect(() => {
    register("balance", {
      required: "El monto inicial es requerido.",
      validate: (value) =>
        Number(value) > 0 || "El monto inicial debe ser mayor a 0.",
    });
  }, [register]);

  useEffect(() => {
    setValue("balance", baseAmount, { shouldValidate: isSubmitted });
  }, [baseAmount, isSubmitted, setValue]);

  return (
    <>
      <Card
        data-testid="form"
        tag={Form}
        className="bg-light"
        onSubmit={handleSubmit(handleSubmitData)}
      >
        <PreloadState
          loading={isSubmitting}
          message="Asignando fondo de reserva..."
        >
          <FalconCardHeader title="Asignar fondo de reserva" light={false} />
          <CardBody>
            <Row form>
              <Col sm tag={FormGroup}>
                <Label for="name">Nombre</Label>
                <Input
                  id="name"
                  name="name"
                  innerRef={register({
                    required: "El nombre del fondo es requerido.",
                    pattern: {
                      value: /^[a-zA-Z0-9 %\u00C0-\u00FF.,:;¡!¿?()\-_"']+$/i,
                      message: "Solo se aceptan alfanúmericos.",
                    },
                  })}
                  /*          onChange={(event) => {
                    register("name");
                    setValue("name", event.target.value);
                  }} */
                  /*    value={watch("name")} */
                  autoComplete="off"
                  placeholder="Nombre del fondo"
                  className={classNames({
                    "border-danger": errors["name"]?.message,
                  })}
                />
                {errors["name"] && (
                  <WizardError
                    error={errors["name"].message}
                    className="fs--1 font-weight-normal d-block"
                  />
                )}
              </Col>
            </Row>
            <FormGroup>
              <Label for="description">Descripción</Label>
              <Input
                autoComplete="off"
                name="description"
                /*      onChange={(event) => {
                  register("description");
                  setValue("description", event.target.value);
                }} */
                /*   value={watch("description")} */
                innerRef={register({
                  required: "La descripción es obligatoria.",
                  pattern: {
                    value: /^[a-zA-Z0-9 %\u00C0-\u00FF.,:;¡!¿?()\-_"']+$/i,
                    message: "Solo se aceptan alfanúmericos.",
                  },
                })}
                /*  onChange={(values) => {
                  setValue("description", values.value);
                }} */
                type={"textarea"}
                className={`${errors["description"]?.message ? "border-danger" : ""
                  } form-control`}
                placeholder="Descripción del fondo"
              />
              <WizardError
                error={errors["description"]?.message}
                className="fs--1 font-weight-normal d-block"
              />
            </FormGroup>
            <ReserveFundAmountFields
              state={amountState}
              label="Monto inicial"
              error={errors["balance"]?.message}
            />

          </CardBody>
          <CardFooter className={classNames("px-md-6 bg-light d-flex")}>
            <ButtonIcon
              color="falcon-default"
              className="ml-auto px-5 mr-2"
              icon={faUndo}
              onClick={() => {
                setRedirectUrl(`/dashboard/finance/${id}/reserve-funds`);
                setRedirect(true);
              }}
              iconAlign="right"
              transform="down-1 shrink-4"
            >
              Volver
            </ButtonIcon>
            <ButtonIcon
              color="primary"
              className="px-5"
              onClick={() => collapseOneOpen(!collapseOne)}
              icon="save"
              iconAlign="right"
              transform="down-1 shrink-4"
            >
              Guardar
            </ButtonIcon>
          </CardFooter>
          <Modal isOpen={collapseOne} data-testid="modal">
            <ModalHeader>Confirmación</ModalHeader>
            <ModalBody>
              <p className="mb-0 font-weight-bold fs--1">
                ¿Está seguro de que ingresó todos los datos correctamente? Esta
                información no puede ser cambiada posteriormente.
              </p>
            </ModalBody>
            <ModalFooter>
              <Button onClick={() => collapseOneOpen(!collapseOne)}>
                Cancelar
              </Button>
              <Button
                data-testid="submit-button"
                color="primary"
                type="submit"
                /*                 disabled={Object.keys(errors).length > 0} */
                onClick={handleSubmit(handleSubmitData)}
              >
                Sí, registrar
              </Button>
            </ModalFooter>
          </Modal>
        </PreloadState>
      </Card>
    </>
  );
};

export default withRedirect(CreateAliquotForm);
